module.exports = __webpack_public_path__ + "img/desktop_redberries.85990cd8.png";